import { Button, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

interface ResetButtonProps {
  className?: string;
  onReset: () => void;
}

export const ResetButton = ({ className, onReset }: ResetButtonProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  return (
    <Tooltip text={t('wizard.preview.reset.description')}>
      <Button className={className} kind="secondary" onClick={onReset} size="s">
        {t('wizard.preview.reset.button')}
      </Button>
    </Tooltip>
  );
};
